import { Route as RouteData } from '../../types/route';
import { USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { RootPage } from '../components/Pages/RootPage';
import AboutSection from '../components/Sections/AboutSection';
import HomeSection from '../components/Sections/HomeSection';
import GallectionsSection from '../components/Sections/GallectionsSection';
import ShopSection from '../components/Sections/ShopSection';
import PostsSection from '../components/Sections/PostsSection';
import StatsSection from '../components/Sections/StatsSection';
import SubscriptionsSection from '../components/Sections/SubscriptionsSection';

export const sectionRoutes = [
  {
    key: 'about',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.ABOUT}`,
    component: AboutSection,
    exact: true,
    loaderName: 'about',
  },
  {
    key: 'home',
    path: '/:username',
    component: HomeSection,
    loaderName: 'home',
    exact: true,
  },
  {
    key: 'gallery',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.GALLERY}/:folderId(\\d+)?/:folderName?`,
    component: GallectionsSection,
    loaderName: 'gallery',
    exact: false,
  },
  {
    key: 'favourites',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.FAVOURITES}/:folderId(\\d+)?/:folderName?`,
    component: GallectionsSection,
    loaderName: 'favourites',
    exact: false,
  },
  {
    key: 'posts',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.POSTS}/:postsSection?/:sortOrder?`,
    component: PostsSection,
    loaderName: 'posts',
    exact: false,
  },
  {
    key: 'shop',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.SHOP}/:shopSection?`,
    component: ShopSection,
    loaderName: 'shop',
    exact: false,
  },
  {
    key: 'stats',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.STATS}`,
    component: StatsSection,
    loaderName: 'stats',
    isForOwnerOnly: true,
    exact: true,
  },
  {
    key: 'subscriptions',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.SUBSCRIPTIONS}`,
    component: SubscriptionsSection,
    loaderName: 'subscriptions',
    featureProtected: 'member_subscriptions',
    exact: false,
  },
] as RouteData[];

export const routes = [
  {
    key: 'root',
    component: RootPage,
    routes: sectionRoutes,
  },
] as RouteData[];

export const DEFAULT_PAGE_LAYOUT = [
  'about',
  'home',
  'gallery',
  'favourites',
  'posts',
  'shop',
  'stats',
  'subscriptions',
];

export const getSectionKeys = () => sectionRoutes.map(v => v.key);
